import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";
import { IAgreement } from "../../types";

export interface IFetchRequiredAgreementsOpts {
  enabled?: boolean;
}

export interface IFetchRequiredAgreementsResponse {
  agreements: Array<IAgreement>;
}

/**
 * Fetches required agreements
 * @returns
 */
export default function useFetchRequiredAgreements(
  opts?: IFetchRequiredAgreementsOpts
): UseQueryResult<IFetchRequiredAgreementsResponse> {
  const axios = useAxios();

  const query = useQuery<IFetchRequiredAgreementsResponse>(
    "requiredAgreements",
    async (): Promise<IFetchRequiredAgreementsResponse> => {
      return await axios
        .get(`/v1/agreements`)
        .then((r) => r.data as IFetchRequiredAgreementsResponse);
    },
    {
      enabled: opts?.enabled ?? true,
    }
  );

  return query;
}
